import { isSegmentClause } from '@gonfalon/clauses/isSegmentClause';

import type { Rule, SegmentRule } from './types';

export const isSegmentRule = (rule: Rule | SegmentRule): rule is SegmentRule => {
  const { clauses } = rule;
  return clauses && clauses.length > 0 && clauses[0] && isSegmentClause(clauses[0]);
};
